import { xlCol, xlColq } from "../../../common/constants";
import { getStaOperatorHamaliLabel, isStaCompany } from '../../../common/helper';

const nonMovementHeaderColumns = [
  {
    id: 0,
    header: 'S/N',
    exportHead: 'S/N',
    field: 'srNo',
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    minWidth: '50px',
    xlCol,
    isSortIcon: false,
  },
  {
    id: 1,
    header: 'LR No.\nMan. LR No',
    exportHead: 'LR Number\nManual LR No',
    field: 'FullLRNo^^ManualLRNo',
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    minWidth: '100px',
    xlCol,
    isSortIcon: true,
  },
  {
    id: 2,
    header: 'Formatted\nLRNO',
    exportHead: 'Formatted LR Number',
    field: 'FormattedLRNO',
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    minWidth: '100px',
    xlCol,
    isSortIcon: true,
  },
  {
    id: 3,
    header: 'Bkg. Date\nBkg. Time',
    exportHead: 'Booking Date\nBooking Time',
    field: 'BookingDate^^BookingTime',
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    minWidth: '100px',
    xlCol,
    isSortIcon: true,
  },
  {
    id: 4,
    header: 'Src. Br.\nDst. Br.',
    exportHead: 'Source Branch\nDestination Branch',
    field: 'BookingBranch^^DestinationBranch',
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    minWidth: '150px',
    xlCol,
    isSortIcon: true,
  },
  {
    id: 5,
    header: 'Sndr. Name\nSndr. No',
    exportHead: 'Sender Name\nSender No',
    field: 'Sender^^SenderContactNo',
    isSelected: true,
    isDefault: false,
    isMandatory: false,
    minWidth: '120px',
    xlCol,
    isSortIcon: true,
  },
  {
    id: 6,
    header: 'Rec. Name\nRec. No',
    exportHead: 'Receiver Name\nReceiver No',
    field: 'Receiver^^ReceiverContactNo',
    isSelected: true,
    isDefault: false,
    isMandatory: false,
    minWidth: '120px',
    xlCol,
    isSortIcon: true,
  },
  {
    id: 7,
    header: 'Pymt.\nType',
    exportHead: 'Payment Type',
    field: 'PaymentType',
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    minWidth: '100px',
    xlCol,
    isSortIcon: true,
  },
  {
    id: 8,
    header: 'Curr. City\nCurr. Branch',
    exportHead: 'Current City\nCurrent Branch',
    field: 'CurrentCity^^CurrentBranch',
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    minWidth: '150px',
    xlCol,
    isSortIcon: true,
  },
  {
    id: 9,
    header: 'LR Status\nSince Days',
    exportHead: 'LR Status\nSince Days',
    field: 'LastStatus^^DaysInterval',
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    minWidth: '100px',
    xlCol,
    isSortIcon: true,
  },
  {
    id: 10,
    header: 'Not Moved\nSince',
    exportHead: 'Not Moved Since',
    field: 'LastTransactionTime',
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    minWidth: '100px',
    xlCol,
    isSortIcon: true,
  },
  {
    id: 11,
    header: 'Booked\nBy user',
    exportHead: 'Booked By user',
    field: 'BookedByUser',
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    minWidth: '80px',
    xlCol,
    isSortIcon: true,
  },
  {
    id: 12,
    header: 'Units',
    exportHead: 'Units',
    field: 'NOP',
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    minWidth: '80px',
    xlCol: xlColq,
    isSortIcon: true,
  },
  {
    id: 13,
    header: 'Frgt.\nChrg',
    exportHead: 'Freight Charge',
    field: 'Freight',
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    minWidth: '80px',
    xlCol: xlColq,
    isSortIcon: true,
  },
  {
    id: 14,
    header: 'Doc.\nchrg',
    exportHead: 'Document Charge',
    field: 'DocumentCharges',
    isSelected: true,
    isDefault: false,
    isMandatory: false,
    minWidth: '80px',
    xlCol: xlColq,
    isSortIcon: true,
  },
  {
    id: 15,
    header: 'Cart.\nChrg',
    exportHead: 'Cartage Charge',
    field: 'CartageAmount',
    isSelected: true,
    isDefault: false,
    isMandatory: false,
    minWidth: '80px',
    xlCol: xlColq,
    isSortIcon: true,
  },
  {
    id: 16,
    header: 'Ham.\nChrg.',
    exportHead: 'Hamali Charge',
    field: 'HamaliCharges',
    isSelected: true,
    isDefault: false,
    isMandatory: false,
    minWidth: '80px',
    xlCol: xlColq,
    isSortIcon: true,
  },
  {
    id: 17,
    header: 'Op.\nHam',
    exportHead: 'Operator Hamali Charge',
    field: 'OperatorHamaliChg',
    isSelected: true,
    isDefault: false,
    isMandatory: false,
    minWidth: '80px',
    xlCol: xlColq,
    isSortIcon: true,
  },
  {
    id: 18,
    header: 'Val.\nChrg.',
    exportHead: 'Valuation Charge',
    field: 'Valuation',
    isSelected: true,
    isDefault: false,
    isMandatory: false,
    minWidth: '80px',
    xlCol: xlColq,
    isSortIcon: true,
  },
  {
    id: 19,
    header: 'oth.\nChrg.',
    exportHead: 'Other Charge',
    field: 'OtherCharges',
    isSelected: true,
    isDefault: false,
    isMandatory: false,
    minWidth: '80px',
    xlCol: xlColq,
    isSortIcon: true,
  },
  {
    id: 20,
    header: 'Bkg.\nGST.',
    exportHead: 'Booking GST',
    field: 'ServiceTaxAmount',
    isSelected: true,
    isDefault: false,
    isMandatory: false,
    minWidth: '80px',
    xlCol: xlColq,
    isSortIcon: true,
  },
  {
    id: 21,
    header: 'Net.\nAmt.',
    exportHead: 'Net Amount',
    field: 'NetAmount',
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    minWidth: '80px',
    xlCol: xlColq,
    isSortIcon: true,
  },
]
export const nonMovementHeader = (companyId) =>
  nonMovementHeaderColumns.map((col) =>
    col.field === 'OperatorHamaliChg'
      ? {
          ...col,
          header: isStaCompany(companyId) ? getStaOperatorHamaliLabel(true) : col.header,
          exportHead: isStaCompany(companyId) ? getStaOperatorHamaliLabel(false) : col.exportHead,
        }
      : col
  )
export const nonMovementFilter = [
  { header: 'State', dataKey: "stateName", xlCol },
  { header: 'City', dataKey: "cityName", xlCol },
  { header: 'Branch', dataKey: "BranchName", xlCol },
  { header: 'Payment Type', dataKey: "paymentTypeName", xlCol },
  { header: 'Report Option', dataKey: "reportOption", xlCol },
  { header: 'Crossing Transaction', dataKey: "crossingTransactions", xlCol },
  { header: 'LR Status', dataKey: "Status", xlCol },
]

export const DetailsReportHeaderExcel = (companyId) => [
  { header: 'S/N', field: 'srNo', headerSx: { textAlign: 'left', minWidth: "50px" } },
  { header: 'LR No.', field: 'FullLRNo', headerSx: { textAlign: 'left', minWidth: "100px" }, },
  { header: 'Man. LR No', field: 'FullLRNo', headerSx: { textAlign: 'left', minWidth: "100px" }, },
  { header: 'Bkg. Date', field: 'BookingDateTime', headerSx: { textAlign: 'left', minWidth: "100px" }, },
  { header: 'Bkg. Time', field: 'BookingDateTime', headerSx: { textAlign: 'left', minWidth: "100px" }, },
  { header: 'Src. Br.', field: 'BookingBranch', headerSx: { textAlign: 'left', minWidth: "150px" }, },
  { header: 'Dst. Br.', field: 'BookingBranch', headerSx: { textAlign: 'left', minWidth: "150px" }, },
  { header: 'Sndr. Name', field: 'Sender', headerSx: { textAlign: 'left', minWidth: "120px" }, },
  { header: 'Sndr. No', field: 'Sender', headerSx: { textAlign: 'left', minWidth: "120px" } },
  { header: 'Rec. Name', field: 'Receiver', headerSx: { textAlign: 'left', minWidth: "120px" }, },
  { header: 'Rec. No', field: 'Receiver', headerSx: { textAlign: 'left', minWidth: "120px" }, },
  { header: 'Pymt. Type', field: 'PaymentType', headerSx: { textAlign: 'left', minWidth: "100px" }, },
  { header: 'Curr. City', field: 'CurrentCity', headerSx: { textAlign: 'left', minWidth: "150px" }, },
  { header: 'Curr. Branch', field: 'CurrentCity', headerSx: { textAlign: 'left', minWidth: "150px" }, },
  { header: 'LR Status', field: 'LastStatus', headerSx: { textAlign: 'left', minWidth: "100px" } },
  { header: 'Since Days', field: 'LastStatus', headerSx: { textAlign: 'left', minWidth: "100px" } },
  { header: 'Not Moved Since', field: 'LastTransactionTime', headerSx: { textAlign: 'left', minWidth: "80px" }, },
  { header: 'Booked By User', field: 'BookedByUser', headerSx: { textAlign: 'right', minWidth: "80px" } },
  { header: 'Units', field: 'NOP', headerSx: { textAlign: 'right', minWidth: "80px" } },
  { header: 'Frgt. Chrg', field: 'Freight', headerSx: { textAlign: 'right', minWidth: "80px" }, },
  { header: 'Doc. chrg', field: 'DocumentCharges', headerSx: { textAlign: 'right', minWidth: "80px" }, },
  { header: 'Cart. Chrg', field: 'CartageAmount', headerSx: { textAlign: 'right', minWidth: "80px" }, },
  { header: 'Ham. Chrg.', field: 'HamaliCharges', headerSx: { textAlign: 'right', minWidth: "80px" }, },
  {
    header: isStaCompany(companyId) ? getStaOperatorHamaliLabel(true) : 'Op. Ham',
    field: 'OperatorHamaliChg',
    headerSx: { textAlign: 'right', minWidth: "80px" },
  },
  { header: 'Val. Chrg.', field: 'Valuation', headerSx: { textAlign: 'right', minWidth: "80px" }, },
  { header: 'oth. Chrg.', field: 'OtherCharges', headerSx: { textAlign: 'right', minWidth: "80px" }, },
  { header: 'Bkg. GST.', field: 'ServiceTaxAmount', headerSx: { textAlign: 'right', minWidth: "80px" }, },
  { header: 'Net. Amt.', field: 'NetAmount', headerSx: { textAlign: 'right', minWidth: "80px" }, },
];

export const paymentWiseSummary = (companyId) => [
  { header: 'S/N', exportHead: 'S/N', field: 'sNo', xlCol: xlCol },
  { header: 'Payment Type', exportHead: 'Payment Type', field: 'PaymentType', xlCol: xlCol, isSortIcon: true, },
  { header: 'LR Count', exportHead: 'LR Count', field: 'TotalLRCount', xlCol: xlColq, isSortIcon: true, },
  { header: 'Units', exportHead: 'Units', field: 'TotalNOP', xlCol: xlColq, isSortIcon: true, },
  { header: 'Freight', exportHead: 'Freight', field: 'TotalFreight', xlCol: xlColq, isSortIcon: true, },
  { header: 'Doc Charge', exportHead: 'Doc Chrg.', field: 'TotalDocumentCharges', xlCol: xlColq, isSortIcon: true, },
  { header: 'Cartage', exportHead: 'Cartage', field: 'TotalCartageAmount', xlCol: xlColq, isSortIcon: true, },
  { header: 'Hamali', exportHead: 'Ham', field: 'TotalHamaliCharges', xlCol: xlColq, isSortIcon: true, },
  {
    header: isStaCompany(companyId) ? getStaOperatorHamaliLabel(false) : 'Operator Hamali',
    exportHead: isStaCompany(companyId) ? getStaOperatorHamaliLabel(false) : 'Op. Ham',
    field: 'TotalOperatorHamaliChg',
    xlCol: xlColq,
    isSortIcon: true,
  },
  { header: 'Valuation Chg', exportHead: 'Val. Chrg', field: 'TotalValuation', xlCol: xlColq, isSortIcon: true, },
  { header: 'Other Chg.', exportHead: 'Other Chrg.', field: 'TotalOtherCharges', xlCol: xlColq, isSortIcon: true, },
  { header: 'Booking GST', exportHead: 'Bkg GST', field: 'TotalServiceTaxAmount', xlCol: xlColq, isSortIcon: true, },
  { header: 'Net Amt', exportHead: 'Net Amt', field: 'TotalNetAmount', xlCol: xlColq, isSortIcon: true, },
];
export const branchWiseSummary = [
  { header: 'S/N', exportHead: 'S/N', field: 'srNo', xlCol, isSortIcon: true, },
  { header: 'Source Branch', exportHead: 'Source Branch', field: 'BookingBranch', xlCol, isSortIcon: true, },
  { header: 'Destination Branch', exportHead: 'Destination Branch', field: 'DestinationBranch', xlCol, isSortIcon: true, },
  { header: 'Payment Type', exportHead: 'Payment Type', field: 'PaymentType', xlCol, isSortIcon: true, },
  { header: 'Unit', exportHead: 'Unit', field: 'NOP', xlCol: xlColq, isSortIcon: true, },
  { header: 'Amount', exportHead: 'Amount', field: 'NetAmount', xlCol: xlColq, isSortIcon: true, },
];
export const gtBookedReceivedPendingSummary = [
  { header: 'SN', exportHead: 'SN', field: 'sNo', xlCol, isSortIcon: true },
  { header: 'Source City/Branch', exportHead: 'Source City/Branch', field: 'SourceBranch', xlCol, isSortIcon: true },
  { header: 'Current City / Branch', exportHead: 'Current City / Branch', field: 'CurrentBranchName', xlCol, isSortIcon: true },
  { header: 'Destination City / Branch', exportHead: 'Destination City / Branch', field: 'DestinationBranchName', xlCol, isSortIcon: true },
  { header: 'Paid', exportHead: 'Booked But Pending Paid', field: 'BookedPaid', xlCol: xlColq, isSortIcon: true, align: 'right' },
  { header: 'To Pay', exportHead: 'Booked But Pending To Pay', field: 'BookedToPay', xlCol: xlColq, isSortIcon: true, align: 'right' },
  { header: 'Paid', exportHead: 'Received But Pending Paid', field: 'ReceivedPaid', xlCol: xlColq, isSortIcon: true, align: 'right' },
  { header: 'To Pay', exportHead: 'Received But Pending To Pay', field: 'ReceivedToPay', xlCol: xlColq, isSortIcon: true, align: 'right' },
  { header: 'Units', exportHead: 'Total Units', field: 'TotalUnits', xlCol: xlColq, isSortIcon: true, align: 'right' },
  { header: 'Amount', exportHead: 'Total Amount', field: 'TotalAmount', xlCol: xlColq, isSortIcon: true, align: 'right' },
];
export const branchwisePendingDispatchSummary = [
  { header: 'Source Branch - Destination Branch', exportHead: 'Source Branch - Destination Branch', field: 'SourceDestinationBranch', xlCol, isSortIcon: true },
  { header: 'City', exportHead: 'City', field: 'DestinationCity', xlCol: xlCol, isSortIcon: true, align: 'left' },
  { header: 'Total Units', exportHead: 'Total Units', field: 'TotalUnits', xlCol: xlColq, isSortIcon: true, align: 'right' },
  { header: 'Total Amount', exportHead: 'Total Amount', field: 'TotalAmount', xlCol: xlColq, isSortIcon: true, align: 'right' },
];
export const destinationWisePendingDispatchSummary = [
  { header: 'Destination Branch', exportHead: 'Destination Branch', field: 'DestinationBranch', xlCol, isSortIcon: true },
  { header: 'Branch', exportHead: 'Branch', field: 'BranchName', xlCol, isSortIcon: true, align: 'left' },
  { header: 'City', exportHead: 'City', field: 'CityName', xlCol, isSortIcon: true, align: 'left' },
  { header: 'Total Units', exportHead: 'Total Units', field: 'TotalUnits', xlCol: xlColq, isSortIcon: true, align: 'right' },
  { header: 'Total Amount', exportHead: 'Total Amount', field: 'TotalAmount', xlCol: xlColq, isSortIcon: true, align: 'right' },
];
export const statusWiseSummary = [
  { header: 'S/N', field: 'sNo', xlCol: xlCol },
  { header: 'Source Branch', field: 'BookingBranch', xlCol: xlCol },
  { header: 'Dest. Branch', field: 'DestinationBranch', xlCol: xlCol },
  { header: 'Pymt Type', field: 'PaymentType', xlCol: xlCol },
  {
    header: 'Booked But Pending Transfer/Disp.',
    colSpan: 3,
    children: [
      { header: 'LR Count', field: 'totalLRB', xlCol: xlColq, isSortIcon: true, },
      { header: 'Total Units', field: 'totalUnitB', xlCol: xlColq, isSortIcon: true, },
      { header: 'Total Amt.', field: 'totalNetAmtB', xlCol: xlColq, isSortIcon: true, },
    ],
  },
  {
    header: 'Trans./Disp. But Pending Rec',
    colSpan: 3,
    children: [
      { header: 'LR Count', field: 'totalLRD', xlCol: xlColq, isSortIcon: true, },
      { header: 'Total Units', field: 'totalUnitD', xlCol: xlColq, isSortIcon: true, },
      { header: 'Total Amt.', field: 'totalNetAmtD', xlCol: xlColq, isSortIcon: true, },
    ],
  },
  {
    header: 'Rec. But Pend. Trans./Dispatch',
    colSpan: 3,
    children: [
      { header: 'LR Count', field: 'totalLRR', xlCol: xlColq, isSortIcon: true, },
      { header: 'Total Units', field: 'totalUnitR', xlCol: xlColq, isSortIcon: true, },
      { header: 'Total Amt.', field: 'totalNetAmtR', xlCol: xlColq, isSortIcon: true, },
    ],
  },
  {
    header: 'Received But Pending Delivery',
    colSpan: 3,
    children: [
      { header: 'LR Count', field: 'totalLRDR', xlCol: xlColq, isSortIcon: true, },
      { header: 'Total Units', field: 'totalUnitDR', xlCol: xlColq, isSortIcon: true, },
      { header: 'Total Amt.', field: 'totalNetAmtDR', xlCol: xlColq, isSortIcon: true, },
    ],
  },
]

export const paymentTypeWiseSummaryColumns = (companyId) => [
  { headerName: 'S/N', exportHead: 'S/N', field: 'sNo', xlCol: { dataType: 'number', dataFormatter: null }, headerSx: { minWidth: '20px', textAlign: 'right' } },
  { headerName: 'Payment Type', exportHead: 'Payment Type', field: 'PaymentType', xlCol: { dataType: 'string', dataFormatter: null }, headerSx: { minWidth: '100px', textAlign: 'left' } },
  { headerName: 'LR Count', exportHead: 'LR Count', field: 'TotalLRCount', xlCol: { dataType: 'quantity', dataFormatter: null }, headerSx: { minWidth: '100px', textAlign: 'right' } },
  { headerName: 'Units', exportHead: 'Units', field: 'TotalNOP', xlCol: { dataType: 'quantity', dataFormatter: null }, headerSx: { minWidth: '80px', textAlign: 'right' } },
  { headerName: 'Freight', exportHead: 'Freight', field: 'TotalFreight', xlCol: { dataType: 'currency', dataFormatter: null }, headerSx: { minWidth: '80px', textAlign: 'right' } },
  { headerName: 'Doc Charge', exportHead: 'Doc Chrg.', field: 'TotalDocumentCharges', xlCol: { dataType: 'currency', dataFormatter: null }, headerSx: { minWidth: '100px', textAlign: 'right' } },
  { headerName: 'Cartage', exportHead: 'Cartage', field: 'TotalCartageAmount', xlCol: { dataType: 'currency', dataFormatter: null }, headerSx: { minWidth: '80px', textAlign: 'right' } },
  { headerName: 'Hamali', exportHead: 'Ham', field: 'TotalHamaliCharges', xlCol: { dataType: 'currency', dataFormatter: null }, headerSx: { minWidth: '80px', textAlign: 'right' } },
  {
    headerName: isStaCompany(companyId) ? getStaOperatorHamaliLabel(false) : 'Operator Hamali',
    exportHead: isStaCompany(companyId) ? getStaOperatorHamaliLabel(false) : 'Op. Ham',
    field: 'TotalOperatorHamaliChg',
    xlCol: { dataType: 'currency', dataFormatter: null },
    headerSx: { minWidth: '120px', textAlign: 'right' },
  },
  { headerName: 'Valuation Chg', exportHead: 'Val. Chrg', field: 'TotalValuation', xlCol: { dataType: 'currency', dataFormatter: null }, headerSx: { minWidth: '120px', textAlign: 'right' } },
  { headerName: 'Other Chg.', exportHead: 'Other Chrg.', field: 'TotalOtherCharges', xlCol: { dataType: 'currency', dataFormatter: null }, headerSx: { minWidth: '100px', textAlign: 'right' } },
  { headerName: 'Booking GST', exportHead: 'Bkg GST', field: 'TotalServiceTaxAmount', xlCol: { dataType: 'currency', dataFormatter: null }, headerSx: { minWidth: '120px', textAlign: 'right' } },
  { headerName: 'Net Amt', exportHead: 'Net Amt', field: 'TotalNetAmount', xlCol: { dataType: 'currency', dataFormatter: null }, headerSx: { minWidth: '80px', textAlign: 'right' } },
];

export const DetailsReportHeaderExcelFormattedLRNO = (companyId) => [
  { header: 'S/N', field: 'srNo', headerSx: { textAlign: 'left', minWidth: "50px" } },
  { header: 'Formatted LRNO', field: 'FormattedLRNO', headerSx: { textAlign: 'left', minWidth: "100px" }, },
  { header: 'Man. LR No', field: 'FullLRNo', headerSx: { textAlign: 'left', minWidth: "100px" }, },
  { header: 'Bkg. Date', field: 'BookingDateTime', headerSx: { textAlign: 'left', minWidth: "100px" }, },
  { header: 'Bkg. Time', field: 'BookingDateTime', headerSx: { textAlign: 'left', minWidth: "100px" }, },
  { header: 'Src. Br.', field: 'BookingBranch', headerSx: { textAlign: 'left', minWidth: "150px" }, },
  { header: 'Dst. Br.', field: 'BookingBranch', headerSx: { textAlign: 'left', minWidth: "150px" }, },
  { header: 'Sndr. Name', field: 'Sender', headerSx: { textAlign: 'left', minWidth: "120px" }, },
  { header: 'Sndr. No', field: 'Sender', headerSx: { textAlign: 'left', minWidth: "120px" } },
  { header: 'Rec. Name', field: 'Receiver', headerSx: { textAlign: 'left', minWidth: "120px" }, },
  { header: 'Rec. No', field: 'Receiver', headerSx: { textAlign: 'left', minWidth: "120px" }, },
  { header: 'Pymt. Type', field: 'PaymentType', headerSx: { textAlign: 'left', minWidth: "100px" }, },
  { header: 'Curr. City', field: 'CurrentCity', headerSx: { textAlign: 'left', minWidth: "150px" }, },
  { header: 'Curr. Branch', field: 'CurrentCity', headerSx: { textAlign: 'left', minWidth: "150px" }, },
  { header: 'LR Status', field: 'LastStatus', headerSx: { textAlign: 'left', minWidth: "100px" } },
  { header: 'Since Days', field: 'LastStatus', headerSx: { textAlign: 'left', minWidth: "100px" } },
  { header: 'Not Moved Since', field: 'LastTransactionTime', headerSx: { textAlign: 'left', minWidth: "80px" }, },
  { header: 'Booked By User', field: 'BookedByUser', headerSx: { textAlign: 'right', minWidth: "80px" } },
  { header: 'Units', field: 'NOP', headerSx: { textAlign: 'right', minWidth: "80px" } },
  { header: 'Frgt. Chrg', field: 'Freight', headerSx: { textAlign: 'right', minWidth: "80px" }, },
  { header: 'Doc. chrg', field: 'DocumentCharges', headerSx: { textAlign: 'right', minWidth: "80px" }, },
  { header: 'Cart. Chrg', field: 'CartageAmount', headerSx: { textAlign: 'right', minWidth: "80px" }, },
  { header: 'Ham. Chrg.', field: 'HamaliCharges', headerSx: { textAlign: 'right', minWidth: "80px" }, },
  {
    header: isStaCompany(companyId) ? getStaOperatorHamaliLabel(true) : 'Op. Ham',
    field: 'OperatorHamaliChg',
    headerSx: { textAlign: 'right', minWidth: "80px" },
  },
  { header: 'Val. Chrg.', field: 'Valuation', headerSx: { textAlign: 'right', minWidth: "80px" }, },
  { header: 'oth. Chrg.', field: 'OtherCharges', headerSx: { textAlign: 'right', minWidth: "80px" }, },
  { header: 'Bkg. GST.', field: 'ServiceTaxAmount', headerSx: { textAlign: 'right', minWidth: "80px" }, },
  { header: 'Net. Amt.', field: 'NetAmount', headerSx: { textAlign: 'right', minWidth: "80px" }, },
];
export const DetailsReportHeaderExcelForBoth = (companyId) => [
  { header: 'S/N', field: 'srNo', headerSx: { textAlign: 'left', minWidth: "50px" } },
  { header: 'LR No.', field: 'FullLRNo', headerSx: { textAlign: 'left', minWidth: "100px" }, },
  { header: 'Formatted LRNO', field: 'FormattedLRNO', headerSx: { textAlign: 'left', minWidth: "100px" }, },
  { header: 'Man. LR No', field: 'FullLRNo', headerSx: { textAlign: 'left', minWidth: "100px" }, },
  { header: 'Bkg. Date', field: 'BookingDateTime', headerSx: { textAlign: 'left', minWidth: "100px" }, },
  { header: 'Bkg. Time', field: 'BookingDateTime', headerSx: { textAlign: 'left', minWidth: "100px" }, },
  { header: 'Src. Br.', field: 'BookingBranch', headerSx: { textAlign: 'left', minWidth: "150px" }, },
  { header: 'Dst. Br.', field: 'BookingBranch', headerSx: { textAlign: 'left', minWidth: "150px" }, },
  { header: 'Sndr. Name', field: 'Sender', headerSx: { textAlign: 'left', minWidth: "120px" }, },
  { header: 'Sndr. No', field: 'Sender', headerSx: { textAlign: 'left', minWidth: "120px" } },
  { header: 'Rec. Name', field: 'Receiver', headerSx: { textAlign: 'left', minWidth: "120px" }, },
  { header: 'Rec. No', field: 'Receiver', headerSx: { textAlign: 'left', minWidth: "120px" }, },
  { header: 'Pymt. Type', field: 'PaymentType', headerSx: { textAlign: 'left', minWidth: "100px" }, },
  { header: 'Curr. City', field: 'CurrentCity', headerSx: { textAlign: 'left', minWidth: "150px" }, },
  { header: 'Curr. Branch', field: 'CurrentCity', headerSx: { textAlign: 'left', minWidth: "150px" }, },
  { header: 'LR Status', field: 'LastStatus', headerSx: { textAlign: 'left', minWidth: "100px" } },
  { header: 'Since Days', field: 'LastStatus', headerSx: { textAlign: 'left', minWidth: "100px" } },
  { header: 'Not Moved Since', field: 'LastTransactionTime', headerSx: { textAlign: 'left', minWidth: "80px" }, },
  { header: 'Booked By User', field: 'BookedByUser', headerSx: { textAlign: 'right', minWidth: "80px" } },
  { header: 'Units', field: 'NOP', headerSx: { textAlign: 'right', minWidth: "80px" } },
  { header: 'Frgt. Chrg', field: 'Freight', headerSx: { textAlign: 'right', minWidth: "80px" }, },
  { header: 'Doc. chrg', field: 'DocumentCharges', headerSx: { textAlign: 'right', minWidth: "80px" }, },
  { header: 'Cart. Chrg', field: 'CartageAmount', headerSx: { textAlign: 'right', minWidth: "80px" }, },
  { header: 'Ham. Chrg.', field: 'HamaliCharges', headerSx: { textAlign: 'right', minWidth: "80px" }, },
  {
    header: isStaCompany(companyId) ? getStaOperatorHamaliLabel(true) : 'Op. Ham',
    field: 'OperatorHamaliChg',
    headerSx: { textAlign: 'right', minWidth: "80px" },
  },
  { header: 'Val. Chrg.', field: 'Valuation', headerSx: { textAlign: 'right', minWidth: "80px" }, },
  { header: 'oth. Chrg.', field: 'OtherCharges', headerSx: { textAlign: 'right', minWidth: "80px" }, },
  { header: 'Bkg. GST.', field: 'ServiceTaxAmount', headerSx: { textAlign: 'right', minWidth: "80px" }, },
  { header: 'Net. Amt.', field: 'NetAmount', headerSx: { textAlign: 'right', minWidth: "80px" }, },
];
export const calculateTotalTableWidth = (columns) => {
  let totalWidth = 0;
  columns.forEach((column) => {
    const minCellWidth = column.pdfColSx.minCellWidth;
    totalWidth += minCellWidth;
  });

  return totalWidth;
};
export const calculateDynamicFormatLandscape = (desiredWidth) => {
  const a4LandscapeAspectRatio = 1122 / 793;

  const dynamicHeight = Math.round(desiredWidth / a4LandscapeAspectRatio);

  return [desiredWidth, dynamicHeight];
};
export const calculateDynamicFormatPortrait = (desiredWidth) => {
  const a4LandscapeAspectRatio = 793 / 1122;

  const dynamicHeight = Math.round(desiredWidth / a4LandscapeAspectRatio);

  return [desiredWidth, dynamicHeight];
};
